import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack, xcss } from '@atlaskit/primitives';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';
import { ContentStatus } from '@confluence/page-utils/entry-points/enums';
import { useContentStatus } from '@confluence/page-utils/entry-points/useContentStatus';

import { useElementVisibility, ELEMENTS } from '../hooks/useIsElementVisible';

import { CreatedRow } from './CreatedRow';
import { LengthRow } from './LengthRow';
import { ViewsRowWrapper as ViewsRow } from './ViewsRow';

const i18n = defineMessages({
	statsSectionTitle: {
		id: 'details-panel.stats-section.title',
		defaultMessage: 'Stats',
		description:
			'Title for the section containing content statistics, e.g. views, length, creation date',
	},
});

const statsSectionStyles = xcss({
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
	marginTop: 'space.300',
});

export const StatsSection = () => {
	const { isElementVisible } = useElementVisibility();
	const { contentStatus } = useContentStatus();
	const isDraft = contentStatus === ContentStatus.DRAFT;

	return (
		<Stack xcss={statsSectionStyles}>
			<FormattedMessage {...i18n.statsSectionTitle} tagName="h4" />
			<ErrorBoundary attribution={Attribution.DISCO}>
				<Stack>
					{isElementVisible(ELEMENTS.ROWS.VIEWS) && !isDraft && <ViewsRow />}
					{isElementVisible(ELEMENTS.ROWS.LENGTH) && <LengthRow />}
					<CreatedRow />
				</Stack>
			</ErrorBoundary>
		</Stack>
	);
};
